import React from "react";

import { Typography } from "../Elements";
import { iconForThemisModuleIdentifier } from "../helpers/iconForThemisModuleIdentifier";
import { nameForThemisModuleIdentifier } from "../helpers/nameForThemisModuleIdentifier";

type Props = {
  moduleIdentifier: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  color?: any; // TODO: PropTypes.oneOf(THEMIS_COLORS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  size?: any; // TODO: PropTypes.oneOf(THEMIS_TYPOGRAPHY_SIZES)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  weight?: any; // TODO: PropTypes.oneOf(THEMIS_TYPOGRAPHY_WEIGHTS)
};

const PolicyLabel = ({ moduleIdentifier, color, size, weight }: Props) => {
  // @ts-expect-error TS(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  const name = nameForThemisModuleIdentifier(moduleIdentifier);
  return (
    <div className="policy-label">
      <img
        className="policy-label__icon"
        alt={`${name} logo`}
        // @ts-expect-error TS(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        src={iconForThemisModuleIdentifier(moduleIdentifier)}
      />
      <Typography label={name} color={color} size={size} weight={weight} />
    </div>
  );
};

PolicyLabel.defaultProps = {
  color: "generalMidnightDark",
  size: "xs",
  weight: "semiBold",
};

export default PolicyLabel;
